import { HausbankFieldTypes } from 'hausbank/inquiry/fields';

type HausbankPurposeFieldTypes = HausbankFieldTypes['financingNeedPage']['purposeSection'];

export const mapHausbankPurpose = (values: HausbankPurposeFieldTypes) => ({
  purpose_kinds: values.purposeKind.map((purpose) => purpose.id),
  project_description: values.projectDescription,
});
